import React from 'react';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  light?: boolean;
  className?: string;
}
export function SectionHeading({
  title,
  subtitle,
  align = 'center',
  light = false,
  className = ''
}: SectionHeadingProps) {
  return <div className={`mb-12 ${align === 'center' ? 'text-center' : 'text-left'} ${className}`} data-id="element-200">
      <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${light ? 'text-white' : 'text-caces-navy'}`} data-id="element-201">
        {title}
      </h2>
      {subtitle && <p className={`text-lg max-w-2xl mx-auto ${light ? 'text-caces-light' : 'text-gray-600'}`} data-id="element-202">
          {subtitle}
        </p>}
      <div className={`mt-4 h-1 w-20 bg-caces-accent rounded-full ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-203" />
    </div>;
}